// Define the supported base languages
const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'pt', 'de'];

export async function loadLocale(langCode) {
	const getDefaultLocale = async () => {
		// If the language code is not supported, you could default to English
		try {
			const defaultLocale = await import(`./locales/en.js`);
			return defaultLocale.default;
		} catch (error) {
			console.error('Could not load the default English locale file.', error);
			return null;
		}
		// const defaultLocale = await import(`./locales/en.js`);
		// return defaultLocale.default;
	};

	if (!langCode) {
		console.log(`Invalid language code: ${langCode}`);
		return await getDefaultLocale();
		// throw new Error(`Invalid language code: ${langCode}`);
	}

	// Normalize the language code
	const baseLang = langCode.split('-')[0].toLowerCase();

	// If the base language is supported, proceed to import the corresponding file
	if (SUPPORTED_LANGUAGES.includes(baseLang)) {
		try {
			// Dynamically import the locale file based on the normalized language code
			const locale = await import(`./locales/${baseLang}.js`);
			return locale.default;
		} catch (error) {
			console.log(`Could not load locale file for language: ${baseLang}`, error);
			return await getDefaultLocale();
			return null;
		}
	}
}
